import HarrySDK from '@nackle/harry-sdk';
import { harryUrl } from 'endpoints';
import fetch from '../utils/fetch';

export default new HarrySDK( harryUrl, fetch );

export const getPreRequisites = async () => {
    try {
        const res = await fetch( `${ harryUrl }/preRequisites`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        } );
        const data = await res.json();
        return data;
    } catch ( error ) {
        throw new Error( error );
    }
};